import { HorizontalLine } from "pages/Dashboard/components/styled";

export function CoverageDetailsLine({
  title,
  planCoverageDescription,
  date,
  benefitEntities,
  insuranceType,
}: {
  title?: string | null;
  planCoverageDescription?: string | null;
  date?: { Date: string | null; Type: string | null } | null;
  benefitEntities: any;
  insuranceType?: string | null;
}) {
  return (
    <div className="flex flex-column">
      <div
        style={{ paddingLeft: "54px" }}
        className="flex flex-row gap-2 items-center pr-4 justify-content-between"
      >
        <div className="flex flex-column">
          <p className="text-sm">{title}</p>
        </div>
        <div className="flex flex-column align-items-end">
          <p className="text-primary-500 font-semibold">
            {planCoverageDescription}
          </p>
          {insuranceType ? (
            <p className="text-gray-600 text-xs font-medium mt-2">
              Policy type: {insuranceType}
            </p>
          ) : null}
          <p className="text-gray-600 text-xs font-medium mt-2">
            {date?.Type || ""}
            {date?.Type && date?.Date && ":"} {date?.Date || ""}
          </p>
        </div>
      </div>
      {benefitEntities?.length ? (
        <div
          style={{ paddingLeft: "54px" }}
          className="flex flex-column gap-2 items-center pr-4 justify-content-between mt-2"
        >
          {benefitEntities?.map((b: any) => (
            <div className=" pl-2 flex flex-row gap-2 items-center  justify-content-between">
              <p className="text-sm text-gray-700">{b?.EntityType}</p>
              <p className="text-gray-800 font-semibold text-sm">
                {b?.Firstname || null} {b?.Lastname_R || null}
              </p>
            </div>
          ))}
        </div>
      ) : null}
      <HorizontalLine marginTop="5px" marginBottom="5px" />
    </div>
  );
}
